import { AlertCircle } from "lucide-react";

/** Message sous un champ obligatoire vide (après tentative d'envoi). */
export function FieldError({ show, message = "Champ obligatoire", testId }) {
  if (!show) return null;
  return (
    <div className="flex items-center gap-1 mt-1 text-[11px]" style={{ color: "#e5484d" }} data-testid={testId || "field-error"} role="alert">
      <AlertCircle size={11} strokeWidth={2.4} />{message}
    </div>
  );
}

/** Ligne récapitulative « Champs requis manquants : … » (en tête ou pied de formulaire). */
export function MissingSummary({ errors = {}, testId = "missing-hint", className = "" }) {
  const labels = Object.values(errors);
  if (!labels.length) return null;
  return (
    <div className={`flex items-start gap-1.5 text-xs ${className}`} style={{ color: "#f87171" }} data-testid={testId} role="alert">
      <AlertCircle size={13} strokeWidth={2.4} className="shrink-0 mt-px" />
      <span>Champs requis manquants : {labels.join(", ")}</span>
    </div>
  );
}
